import React, { ReactElement, useEffect, useState } from 'react';
import ProductTile from 'components/common/ProductTile';
import { Product } from 'utils/Product';
import CartContentsMessage from 'components/common/CartContentsMessage';
import { searchWithinProducts, useSearchTerms } from 'utils/search';
import { Button } from 'components/common/Button';
import ReactLoading from 'react-loading';
import { useVisibleProducts } from 'app-state/product-cache';
import { IconLoader } from 'components/common/Icon';

const ShopPage = (): ReactElement => {
  const { searchTerms, searchString } = useSearchTerms();
  const { status, products: allProducts } = useVisibleProducts();
  const [products, setProducts] = useState<Product[] | undefined>(undefined);

  useEffect(() => {
    if ((status === 'Ok' || status === 'Stale') && allProducts) {
      setProducts(searchWithinProducts(allProducts, searchTerms));
    }
  }, [searchString, status]);

  return (
    <React.Fragment>
      <div className='mb-3'><CartContentsMessage button /></div>
      {status === 'Loading'
        && <ReactLoading className='m-auto' type={'bubbles'} color={'#ac542e'} height={'50%'} width={'8%'} />}
      {status === 'Stale' && <IconLoader />}
      {(status === 'Ok' || status === 'Stale') && products && <div className='my-7'>
        {searchTerms.length > 0 && <div className='mb-5'>
          <span id='search-info' className='mx-5 text-xl'>
            Searching for: {searchTerms.map(st => `"${st}"`).join(', ')}
          </span>
          <Button grey id='clear-search-button' linkTo='/shop'>Clear Search</Button>
          {products.length === 0
            && <div className='mt-16 text-red-600 text-xl'>Your search didn&apos;t find any products.</div>}
        </div>}
        <div className='grid grid-cols-3 mx-auto max-w-4xl text-base font-medium leading-6'>
          {products && products.map((product: Product) => <ProductTile key={product.id} product={product} />)}
        </div>
      </div>}
      {status === 'Error'
        && <div className='mt-16 text-red-600 text-xl'>An error occurred finding products.</div>}
    </React.Fragment>
  );
};
export default ShopPage;
